<script>
import axios from "@/utils/axios";
import { samplingUsers } from "@/utils/user";
import StatusBadge from "@/components/common/sampling-status-badge.vue";
import { states, pincodeWiseAddress } from '@/utils/admin';
import { useMasterDataStore } from '@/stores/useMasterDataStore';

export default {
  inject: ["setLoading"],
  components: {
    StatusBadge,
  },
  data() {
    return {
      id: null,
      ids: [],
      users: [],
      errors: {},
      action: "",
      parties: [],
      currency: "",
      user_id: null,
      app_currency: "",
      request_number: "",
      party_id: "",
      party_type: "",
      status: "",
      address: "",
      // countries: [],
      states: [],
      city: '',
      state: null,
      country: null,
      pincode: '',
      loading: false,
      tracking_number: "",
      dispatched_at: "",
      delivered_at: "",
      selectedParty: null,
      allItems: [],
      items: [{ item: null, qty: 1 }],
      module_url: "sampling-requests",
    };
  },

  watch: {
    party_type(newVal, oldVal) {
      if (newVal !== oldVal && !this.id) {
        // Clear selected party and party_id if type changed
        this.selectedParty = null;
        // If you store party_id separately:
        this.party_id = null;
        // Also clear parties array if you want
        this.parties = [];
      }
    },
  },

  computed: {
  countries() { return useMasterDataStore().countries || [] },
},

  async mounted() {
    this.payment_date = this.$currentDate();
    this.app_currency = await this.$appCurrency();
    this.getCountries();
  },

  methods: {
    async sampling(row = null) {
      this.resetForm();
      this.getUsers();
      this.getAllItems();
      this.party_type = `App\\Models\\Lead`;
      if (row && Object.keys(row).length > 0) {
        this.id = row.id;
        this.status = row.status;
        this.user_id = row.user_id || null;
        this.request_number = row.request_number;
        this.tracking_number = row.tracking_number;
        this.dispatched_at = row.dispatched_at;
        this.delivered_at = row.delivered_at;
        this.city = row.city;
        this.pincode = row.pincode;
        this.country = row.country;
        this.state = row.state;
        this.address = row.address;
        await this.getPartyById(row.party_type, row.party_id);

        // Populate items
        this.items = row.sampling_items.map((row) => {
          const selectedItem = this.allItems.find((i) => i.id === row.item_id);
          const qty = parseFloat(row.quantity || 1);
          return {
            item: selectedItem || { id: row.item_id, name: row.name },
            qty: qty,
          };
        });
      }
    },
  //   async getCountries() {
  //    try {
  //     const response = await countries();
  //     this.countries = response.data.data;
  //     if (!this.id) {
  //      this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
  //     }
  //     this.getStates(this.country?.id);
  //   } catch (error) {
  //    this.$swalToast(error.message, 'error');
  //   }
  //  },

  async getCountries() {
  await useMasterDataStore().loadAll();
  if (!this.id) {
    this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
  }
  this.getStates(this.country?.id);
},

   onCountrySelect(country) {
    this.getStates(country?.id);
   },

async getStates(country_id) {
  this.state = null;
  this.states = [];
  if (country_id) {
    try {
      const response = await states(country_id);
      this.states = response.data.data;
      this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
    } catch (error) {
      this.$swalToast(error.message, 'error');
    }
  }
},

checkPincode() {
  if (this.pincode.length < 6) {
    this.errors.pincode = ["The pincode field must be 6 digits."];
  } else {
    delete this.errors.pincode;
    clearTimeout(this.pincodeTimeout);
    this.pincodeTimeout = setTimeout(() => {
      this.addressByPincode();
    }, 500);
  }
},

async addressByPincode() {
  try {
    const response = await pincodeWiseAddress(this.pincode);
    const data = response.data.data;
    const new_country = data?.country ? this.countries.find(c => c.name === data.country) : this.country;
    this.city = data?.city || this.city;
    if (new_country && new_country?.id !== this.country?.id) {
      this.country = new_country;
      await this.getStates(new_country.id);
      this.state = data?.state ? this.states.find(s => s.name === data.state) : this.state;
    } else if (data?.state) {
      this.state = this.states.find(s => s.name === data.state);
    }
  } catch (error) {
    console.log('Pincode lookup failed:', error.message);
  }
},

    async getPartyById(party_type, id) {
      try {
        let res;
        if (party_type === `App\\Models\\Lead`) {
          res = await axios.get(`/leads/${id}`);
        } else {
          res = await axios.get(`/customers/${id}`);
        }
        this.selectedParty = res.data.data;
        this.onPartySelected(this.selectedParty);
      } catch (err) {
        //this.$swalToast("Party not found", 'error');
      }
    },

    async getAllItems() {
      try {
        const res = await axios.get("/items/dropdown");
        this.allItems = res.data.data;
      } catch (error) {
        this.$swalToast(error.message, "error");
      }
    },

    addItemRow() {
      this.items.push({ item: null, qty: 1 });
    },

    removeItemRow(index) {
      if (this.items.length === 1) return;
      this.items.splice(index, 1);
    },

    onItemSelected(index, selectedItem) {
      const row = this.items[index];
      if (!selectedItem) {
        row.item = null;
        row.qty = 1;
        return;
      }
      row.qty = 1;
    },

    getItemError(index, field) {
      const key = `items.${index}.${field}`;
      return this.errors[key] ? this.errors[key][0] : null;
    },

    async onSearch(search) {
      if (!search || search.length < 2) return;
      this.loading = true;
      try {
        let res;
        if (this.party_type === "App\\Models\\Lead") {
          res = await axios.get("/leads/dropdown", {
            params: { search_keyword: search },
          });
        } else if (this.party_type === "App\\Models\\Customer") {
          res = await axios.get("/customers/dropdown", {
            params: { search_keyword: search },
          });
        }
        this.parties = res.data.data;
      } catch (error) {
        this.$swalToast(error.message, "error");
      } finally {
        this.loading = false;
      }
    },

onPartySelected(party) {
  if (party) {
    this.party_id = party.id;
    this.address = party.address || this.address;
    this.city = party.city || this.city;
    this.pincode = party.pincode || this.pincode;

    // Country match
    if (party.country) {
      const matchedCountry = this.countries.find(c => c.name === party.country);
      if (matchedCountry) {
        this.country = matchedCountry;
        this.getStates(matchedCountry.id).then(() => {
          if (party.state) {
            this.state = this.states.find(s => s.name === party.state) || null;
          }
        });
      }
    }
  } else {
    this.party_id = null;
  }
},
    async getUsers() {
      try {
        const response = await samplingUsers();
        this.users = response.data.data;
      } catch (error) {
        this.$swalToast(error.message, "error");
      }
    },

    createViaParty(party_type, party_id) {
      this.sampling();
      this.party_type = party_type;
      this.getPartyById(party_type, party_id);
    },

    async saveSampling() {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          id: this.id,
          user_id: this.user_id,
          party_type: this.party_type,
          party_id: this.selectedParty?.id,
          address: this.address,
          city: this.city,
          state: this.state?.name,
          country: this.country?.name,
          pincode: this.pincode,
          items: this.items.map((row) => ({
            item_id: row.item?.id || null,
            name: row.item?.name,
            quantity: row.qty,
          })),
        };
        let response = [];
        if (this.id) {
          response = await axios.put(
            `/${this.module_url}/${this.id}/update`,
            payload,
          );
        } else {
          response = await axios.post(`/${this.module_url}/create`, payload);
        }
        this.$swalToast(response.data.message);
        this.$emit("updated");
        this.$closeModal("sampling_modal");
      } catch (error) {
        if (error?.type === "validation") {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, "error");
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deleteSampling() {
      this.errors = {};
      this.setLoading(true);
      try {
        const response = await axios.delete(
          `/${this.module_url}/${this.id}/delete`,
        );
        this.$swalToast(response.data.message);
        this.$emit("updated");
        this.$closeModal("sampling_delete_modal");
      } catch (error) {
        if (error.type == "validation") {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, "error");
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.id = null;
      this.errors = {};
      this.address = "";
      this.city = '';
      this.state = null;
      this.country = null;
      this.pincode = '';
      this.selectedParty = null;
      this.items = [{ item: null, qty: 1 }];
    },
  },
};
</script>

<template>
  <!-- ADD/EDIT -->
  <div class="modal fade" id="sampling_modal">
  <div class="modal-dialog modal-dialog-centered modal-md w-100">
  <div class="modal-content">
  <div class="modal-header">
  <h4 class="modal-title"> {{ id ? "Edit" : "Add" }} Sampling Request</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
    <i class="ti ti-x"></i>
  </button>
  </div>
  <form @submit.prevent="saveSampling">
  <div class="modal-body pb-0">
   <div class="row">
    <div class="col-md-4">
     <label class="form-label fw-semibold">Client Type <span class="text-danger">*</span></label>
      <select class="form-control" v-model="party_type">
       <option value="">Choose any</option>
       <option value="App\Models\Lead" :selected="party_type === `App\\Models\\Lead`"> Lead </option>
       <option value="App\Models\Customer" :selected="party_type === `App\\Models\\Customer`">
          Customer
        </option>
      </select>
      <div v-if="errors.party_type" class="text-danger small mt-1"> {{ errors.party_type[0] }} </div>
      </div>

      <div class="col-md-8" v-if="party_type === `App\\Models\\Lead` || party_type === `App\\Models\\Customer`">
      <label class="form-label fw-semibold">Client <span class="text-danger">*</span></label>
      <vue-select v-model="selectedParty" :options="parties" :loading="loading" :filterable="false" @search="onSearch"
        @update:modelValue="onPartySelected" label="name" class="vue-select-normal" :placeholder=" party_type === `App\\Models\\Lead` ? 'Search and select a lead' : 'Search and select a customer'"/>
      <div v-if="errors.party_id" class="text-danger small mt-1">{{ errors.party_id[0] }}</div>
      </div>

      <div class="col-12 mt-3">
      <label class="form-label fw-semibold">Assign To<span class="text-danger">*</span></label>
      <vue-select :options="users" label="name" placeholder="Sampling User" :reduce="(u) => u.id" v-model="user_id"/>
      <div v-if="errors.user_id" class="text-danger small mt-1">
        {{ errors.user_id[0] }}
      </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-8">
          <label class="form-label">Address</label>
          <input type="text" class="form-control" v-model="address" />
          <div v-if="errors.address" class="text-danger small mt-1">{{ errors.address[0] }}</div>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">Pincode <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="pincode" maxlength="6" @keyup="checkPincode" />
          <small class="text-danger" v-if="errors.pincode">{{ errors.pincode[0] }}</small>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">City <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="city" />
          <small class="text-danger" v-if="errors.city">{{ errors.city[0] }}</small>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">Country <span class="text-danger">*</span></label>
          <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
          <small class="text-danger" v-if="errors.country">{{ errors.country[0] }}</small>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">State <span class="text-danger">*</span></label>
          <vue-select :options="states" label="name" v-model="state" />
          <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
        </div>
      </div>

  <!-- Items Section -->
  <div class="mt-4">
  <div class="d-flex justify-content-between align-items-center mb-3">
  <h5 class="mb-0 fw-bold text-dark small">
    <i class="ti ti-list-details me-1 text-primary"></i>Sampling
    Items
  </h5>
  <a href="javascript:void(0);" class="btn btn-outline-primary btn-sm fw-semibold" @click="addItemRow">
    <i class="ti ti-plus me-1"></i>Add New Item
  </a>
  </div>

  <div v-for="(item, index) in items" :key="index" class="border rounded p-3 mb-3">
  <div class="row align-items-end g-2">
    <!-- Item -->
    <div class="col-md-7">
     <label class="form-label">Item</label>
     <vue-select :options="allItems" label="name" v-model="item.item" @update:modelValue="(val) => onItemSelected(index, val)"/>
     <div class="text-danger small mt-1" v-if="getItemError(index, 'item_id')">{{ getItemError(index, "item_id") }}</div>
    </div>

    <!-- Qty -->
    <div class="col-md-3">
     <label class="form-label">Qty</label>
     <input type="number" class="form-control" v-model.number="item.qty" min="1"/>
      <div class="text-danger small mt-1" v-if="getItemError(index, 'quantity')">
       {{ getItemError(index, "quantity") }}
      </div>
    </div>

    <!-- Delete -->
    <div class="col-md-2 d-flex align-items-end">
     <button type="button" class="btn btn-danger btn-sm w-100" @click="removeItemRow(index)">
       <i class="ti ti-trash"></i>
      </button>
    </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  <div class="modal-footer bg-white border-0 px-4 flex-shrink-0">
    <button type="submit" class="btn btn-primary px-4" @click="save">
      <i class="ti ti-device-floppy me-1"></i>Save
    </button>
  </div>
  </form>
  </div>
  </div>
  </div>
  <!-- ADD/EDIT -->

  <!-- View Details -->
  <div class="modal fade" id="sampling_detail_modal">
  <div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
  <div class="modal-header bg-dark">
  <h4 class="modal-title text-white">Sampling Detail</h4>
  <button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
  </button>
  </div>
  <div class="modal-body">
  <!-- <h5 class="mb-2">Sampling Details</h5> -->
  <div class="border rounded mb-3 p-2">
  <div class="row row-gap-3">
  <div class="col-md-5">
  <div class="text-center">
  <span class="d-block mb-1 fw-bold">Request No</span>
  <p class="text-dark fw-normal">{{ request_number }}</p>
  </div>
  </div>
  <div class="col-md-3">
  <div class="text-center">
  <span class="d-block mb-1 fw-bold">Status</span>
  <p class="text-dark fw-normal">
    <StatusBadge :status="status"></StatusBadge>
  </p>
  </div>
  </div>
  <div class="col-md-4">
  <div class="text-center">
  <span class="d-block mb-1 fw-bold">Tracking No</span>
  <span class="badge bg-soft-pink d-inline-flex align-items-center" style="max-width: 90px;overflow-y: auto;">
    <i class="fas fa-circle fs-6 me-1"></i>{{ tracking_number ?? "N/A" }}
  </span>
  </div>
  </div>
  </div>

  <hr>
  <!-- Address Row -->
  <div class="row mt-2" v-if="address || city || state || country || pincode">
  <div class="col-12">
  <div class="text-start">
  <span class="d-block mb-1 fw-bold">Address</span>
  <p class="text-dark fw-normal mb-0">
    <span v-if="address">{{ address }}, </span>
    <span v-if="city">{{ city }}, </span>
  <span v-if="state">{{ state?.name || state }}, </span>
  <span v-if="country">{{ country?.name || country }}</span>
    <span v-if="pincode"> - {{ pincode }}</span>
  </p>
  </div>
  </div>
  </div>

  </div>

  <div class="schedule-timeline">
  <div class="d-flex align-items-center" v-if="dispatched_at">
    <div class="d-flex align-items-center active-time">
      <span class="timeline-date text-dark">{{$formatDate(dispatched_at)}}</span>
      <span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span>
    </div>
    <div class="flex-fill ps-3 pb-4 timeline-hrline">
      <div class="mt-4">
        <p class="fw-medium text-gray-9 mb-1">
          <span class="badge rounded-pill bg-outline-secondary">Dispatched At</span>
        </p>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center" v-if="delivered_at">
    <div class="d-flex align-items-center active-time">
      <span class="timeline-date text-dark">{{$formatDate(delivered_at)}}</span>
      <span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span>
    </div>
    <div class="flex-fill ps-3 pb-4 timeline-hrline">
      <div class="mt-4">
      <p class="fw-medium text-gray-9 mb-1">
        <span class="badge rounded-pill bg-outline-secondary">Delivered At</span>
      </p>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center">
    <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
  </div>
  </div>

  <table class="table table-bordered" v-if="items.length">
  <thead>
    <tr>
      <th>S.No</th>
      <th>Name</th>
      <th>Quantity</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(row, index) in items || []" :key="row?.item?.id || index">
      <td class="text-center fs-10">{{ index + 1 }}.</td>
      <td>
        <strong class="text-dark fs-10">{{ row?.item?.name }}</strong>
      </td>
      <td class="fs-10">x {{ row?.qty }}</td>
    </tr>
  </tbody>
  </table>
  </div>
  </div>
  </div>
  </div>
  <!-- /View Details -->

  <!-- Delete Modal -->
  <div class="modal fade" id="sampling_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this cant be undone once
            you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteSampling">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>